import { Info, Question } from '@phosphor-icons/react';

import {
  TooltipContent,
  TooltipProvider,
  TooltipRoot,
  TooltipTrigger,
} from '../ui/Tooltip';
import { cn } from '../../utils/cn';

/**
 * @param {object} props
 * @param {string} props.label — nome acessível do gatilho
 * @param {import('react').ReactNode} props.content
 * @param {'top' | 'bottom' | 'left' | 'right'} [props.side]
 * @param {'outline' | 'plain'} [props.appearance] — `plain` é o ícone `info`
 *   de 14px sem contorno usado pelo `.pen` (heroes, section headings);
 *   `outline` mantém o círculo com `?` do resto da app.
 * @param {string} [props.className] — cor do gatilho (herda por omissão)
 */
export function HelpTooltip({
  label,
  content,
  side = 'top',
  appearance = 'outline',
  className,
}) {
  const isPlain = appearance === 'plain';

  return (
    <TooltipProvider delayDuration={200}>
      <TooltipRoot>
        <TooltipTrigger asChild>
          <button
            type="button"
            className={cn(
              'inline-flex shrink-0 items-center justify-center rounded-ds-full',
              isPlain
                ? 'h-3.5 w-3.5 text-current'
                : 'h-3.5 w-3.5 border border-border text-muted-foreground',
              className,
            )}
            aria-label={label}
          >
            {isPlain ? (
              <Info className="h-3.5 w-3.5" aria-hidden />
            ) : (
              <Question className="h-2.5 w-2.5" aria-hidden />
            )}
          </button>
        </TooltipTrigger>
        {/* eslint-disable-next-line no-restricted-syntax -- largura máxima do tooltip */}
        <TooltipContent side={side} className="max-w-[240px]">
          {content}
        </TooltipContent>
      </TooltipRoot>
    </TooltipProvider>
  );
}
